'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/** 
 * @desc {Object} 钩子工具类
 */

// 获取随机字符串
var getRandomString = function getRandomString() {
    var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;

    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz';
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < len; i += 1) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd + '-';
};

var str = getRandomString();
var j = 0;

exports.default = {
    beforeSend: function beforeSend() {},
    afterSend: function afterSend() {},
    before: function before(params, requestType) {
        var idNo = str + j;
        j += 1;
        this.beforeSend({
            idNo: idNo,
            requestType: requestType,
            params: params
        });
        return idNo;
    },
    after: function after(params) {
        this.afterSend(params);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/http-request/dist/utils/hooks.js
// module id = hVPy
// module chunks = 8